import "./Support.scss";
import supportImg from "../../Assets/ProfileSettings/supportImg.png";
import Email from "../../Assets/ProfileSettings/supportEmail.svg";
import Call from "../../Assets/ProfileSettings/supportCall.svg";
import Chat from "../../Assets/ProfileSettings/supportChat.svg";
import Feedback from "../../Assets/ProfileSettings/supportFeedback.svg";
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { useNavigate } from "react-router-dom";
import { API_END_POINTS, GLOBAL_CONSTANTS, ROUTES } from "../../Constants/Constants";
import { axiosInstance } from "../../Utilities/Interceptor/Interceptor";
import { useState } from "react";
import SupportChatRequest from "../SupportChatReq/SupportChatReq";
import toast from "react-hot-toast";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

const Support = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [ChatRequestOpen, setChatRequestOpen] = useState(false);
    const [ChatRequestShowData, setChatRequestShowData] = useState(false);
    const [ChatRequestMeg, setChatRequestMeg] = useState('');

    const handleChatRequestOpen = () => {
        axiosInstance
            .get(`${API_END_POINTS.SUPPORT_CHAT}`)
            .then((Response: any) => {
                if (Response?.data?.status) {
                    var status = Response?.data?.result?.data;
                    if (status?.is_expert === false && status?.user_exist === false) {
                        setChatRequestOpen(true);
                        setChatRequestShowData(true);
                        setChatRequestMeg(Response?.data?.message);
                    } else if (status?.is_expert === true && status?.user_exist === true) {
                        navigate(ROUTES.ADMIN_CHAT, { state: { roomData: status } })
                    } else {
                        setChatRequestOpen(true)
                        setChatRequestShowData(false);
                        setChatRequestMeg(Response?.data?.message);
                    }
                }
            })
            .catch(() => { });

    };

    const handleChatRequestClose = () => {
        setChatRequestOpen(false);
        setChatRequestShowData(false);
        setChatRequestMeg("");
    }

    const openCall = () => {
        navigator.clipboard.writeText('+123456789');
        toast.success("Copied!", {
            position: GLOBAL_CONSTANTS.INITIAL_VALUES.TOAST_POSITION
        });
    };

    const handleEmaiClick = () => {
        window.open('mailto:LearnAndplay@gmail.com', '_blank');
    };

        const language: any = useSelector((state: any) => {
            return state.languageReducer.language;
          });
       
         const ButtonWapperImg = language === GLOBAL_CONSTANTS.LANGUAGES.ENGLISH ? "ButtonWapperImg-Eng" : "ButtonWapperImg-Arab";


    return (
        <>

            {ChatRequestOpen && (
                <div className="overlay-ModelBackround">
                    <SupportChatRequest open={ChatRequestOpen} handleClose={handleChatRequestClose} data={ChatRequestShowData} message={ChatRequestMeg} />
                </div>
            )}
            <div className="Support__container">
                <div className="container__wapper">

                    <div className="img__container">
                        <img src={supportImg} alt="" />
                    </div>

                    <div className="contants mt-3">
                        {t("hello there! our support team will contact you within 24-48 hours once you reach out to them")}
                    </div>

                    <div className="Button__wapper" onClick={handleEmaiClick}>
                        <div className="accordion__lable__wapper">
                            <img src={Email} alt=""/>
                            <div className="text">{t("Email")}</div>
                        </div>
                        <ExpandMoreIcon style={{ transform: 'rotate(270deg)'}} className={`${ButtonWapperImg}`} />
                    </div>
                    <div className="Button__wapper" onClick={openCall}>
                        <div className="accordion__lable__wapper">
                            <img src={Call} alt=""/>
                            <div className="text">{t("Call")}</div>
                        </div>
                        <ExpandMoreIcon style={{ transform: 'rotate(270deg)'}} className={`${ButtonWapperImg}`} />
                    </div>
                 

                </div>

            </div >
        </>
    )
}

export default Support;